<template>
  <div class="input-group">
    <b-form-datepicker
      :id="id"
      v-model="date"
      :min="minDate"
      :max="maxDate"
      class="mb-2"
      :disabled="disabled"
      placeholder="Proszę wybrać..."
      label-prev-decade="Poprzednia dekada"
      label-prev-year="Poprzedni rok"
      label-prev-month="Poprzedni miesiąc"
      label-current-month="Bieżący miesiąc"
      label-next-month="Następny miesiąc"
      label-next-year="Następny rok"
      label-next-decade="Następna dekada"
      label-today="Dzisiaj"
      label-selected="Wybrana data"
      label-no-date-selected="Nie wybrano daty"
      label-calendar="Kalendarz"
      label-nav="Nawigacja"
      label-help="Użyj kursora, aby wybrać datę"
      label-close-button="Zamknij"
      label-reset-button="Resetuj"
      :dark="true"
      :hide-header="true"
    >
      <template v-slot:nav-next-month>
        <BaseIcon name="chevron-right"></BaseIcon>
      </template>
      <template v-slot:nav-next-year>
        <BaseIcon name="chevron-bar-right"></BaseIcon>
      </template>
      <template v-slot:nav-prev-month>
        <BaseIcon name="chevron-left"></BaseIcon>
      </template>
      <template v-slot:nav-prev-year>
        <BaseIcon name="chevron-bar-left"></BaseIcon>
      </template>
      <template v-slot:nav-this-month>
        <BaseIcon name="circle"></BaseIcon>
      </template>
      <template v-slot:button-content>
        <BaseIcon name="calendar"></BaseIcon>
      </template>
    </b-form-datepicker>
  </div>
</template>

<script>
// import { Dropdown, Btn, DatePicker } from 'uiv'
// import MaskedInput from "vue-masked-input";
import moment from "moment";
import BaseIcon from "@/components/Base/Elements/BaseIcon";

export default {
  name: "InfDatePicker",
  components: {
    BaseIcon
  },
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: [String, Date],
      required: true
    },
    minDate: {
      type: [String, Object],
      default: () => moment().format("YYYY-MM-DD")
    },
    maxDate: {
      type: [String, Object],
      default: () =>
        moment()
          .add("1", "years")
          .format("YYYY-MM-DD")
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      date: this.value,

      locale: {
        uiv: {
          datePicker: {
            clear: "Czyść",
            today: "Dzisiaj",
            month: "Miesiąc",
            month1: "Styczeń",
            month2: "Luty",
            month3: "Marzec",
            month4: "Kwiecień",
            month5: "Maj",
            month6: "Czerwiec",
            month7: "Lipiec",
            month8: "Sierpień",
            month9: "Wrzesień",
            month10: "Październik",
            month11: "Listopad",
            month12: "Grudzień",
            year: "Rok",
            week1: "Pon",
            week2: "Wt",
            week3: "Śr",
            week4: "Czw",
            week5: "Pt",
            week6: "So",
            week7: "Nd"
          }
        }
      }
    };
  },
  watch: {
    value: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.date = newValue;
      }
    },
    date: function(e) {
      this.$emit("input", e);
    }
  },
  methods: {
    emitEvent(event) {
      this.$emit("input", event.target.value);
      if (this.v) {
        this.v.$touch();
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/_variables";

.b-form-datepicker {
  button[aria-haspopup] {
    opacity: 0.5;
    svg {
    }
  }
  .dropdown-menu {
    margin: 0 0 0 -1px;
    &.bg-dark {
      border: none;
      // background-color: $col-polmed-blue !important;
      background-color: lighten($col-gray, 27%) !important;
      color: white;

      .b-calendar .form-control[role="application"] {
        background: transparent;
      }

      .border-bottom {
        border-bottom: none !important;
      }

      .border-top {
        border-top: none !important;
      }

      .form-control {
        border: none;
        color: $col-text;

        &:focus {
          box-shadow: none !important;
        }

        > header {
          &.font-weight-bold {
            font-weight: 600 !important;
          }

          + div {
            border-top: 1px solid lighten($col-gray, 15%) !important;
            border-bottom: 1px solid lighten($col-gray, 15%) !important;
            padding: 0.4rem 0;
            margin-bottom: 0.4rem;
          }
        }

        footer {
          display: none;
        }
      }

      .b-calendar-nav {
        justify-content: space-between;
      }

      .btn-outline-secondary {
        color: $col-text !important;
        border-radius: 50%;
        // background: red;
        width: 30px;
        height: 30px;
        padding: 0;
        flex: 0 0 auto !important;
        svg {
          fill: $col-text;
        }
        &:focus {
          box-shadow: none !important;
        }
        &:hover {
          color: white !important;
          svg {
            fill: white;
          }
        }
      }

      .b-calendar-grid-body {
        .bg-light {
          background: transparent !important;
          color: $col-text;
        }

        .btn-light,
        .text-muted,
        .btn-outline-primary,
        .text-dark {
          color: $col-text !important;
        }

        .font-weight-bold {
          font-weight: 600 !important;
        }

        .btn.disabled {
          opacity: 0.4;
        }

        .btn-light,
        .btn-outline-primary {
          background: none;
          box-shadow: 0 0 0 0.1rem lighten($col-primary, 20%) !important;
        }

        .btn-outline-light {
          &:hover {
            background: darken($col-primary, 10%);
            color: white !important;
          }
        }

        .btn-primary:not(:disabled):not(.disabled):active:focus,
        .btn-primary:not(:disabled):not(.disabled).active:focus,
        .show > .btn-primary.dropdown-toggle:focus {
          -webkit-box-shadow: 0 0 0 0.1rem lighten($col-primary, 40%) !important;
          box-shadow: 0 0 0 0.1rem lighten($col-primary, 40%) !important;
        }

        .btn-primary:not(:disabled):not(.disabled):active,
        .btn-primary:not(:disabled):not(.disabled).active,
        .show > .btn-primary.dropdown-toggle {
          background: lighten($col-primary, 20%);
          color: white;
        }
      }
    }

    // .b-calendar > .b-calendar-inner > header {
    //   display: none;
    // }
  }
}
</style>
